import React, { Component } from "react";
import "../App.css";
import logo from "../images/logo.png";
import discord from "../images/icon-discord.png"
import twitter from "../images/icon-twitter.png"
import insta from "../images/icon-insta.png"
import opensea from "../images/icon-opensea.png"
// import { Social_3 } from "./Social";

export default class Navbar extends Component {
    render() {
        return (
            <div className="">
                <nav class="navbar navbar-expand-lg mx-auto navbar-dark">
                    <div className="container">
                        <a class="navbar-brand d-lg-none d-block" href="/">
                            <img className="" style={{ width: "100px" }} src={logo} alt="Logo" />
                        </a>
                        <button
                            class="navbar-toggler"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapsibleNavbar"
                        >
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse " id="collapsibleNavbar">
                            <a href="/">
                                <div className="position-relative">
                                    {/* <div className="new"> */}
                                    <img className="d-md-block d-none" style={{ width: "150px" }} src={logo} alt="Logo" />
                                </div>
                                {/* </div> */}
                            </a>
                            <ul class="navbar-nav mx-auto ">

                                <li class="nav-item active">
                                    <a class="nav-link" href="/">
                                        Home
                                    </a>
                                </li>
                                <li class="nav-item active">
                                    <a class="nav-link" href="/#about">
                                        About
                                    </a>
                                </li>
                                <li class="nav-item active">
                                    <a class="nav-link" href="/#promise">
                                        Promises
                                    </a>
                                </li>

                                <li class="nav-item active">
                                    <a class="nav-link" href="/#team">
                                        Team
                                    </a>
                                </li>
                                {/* <li class="nav-item active">
                                    <a class="nav-link" href="/#faq">
                                        Faq
                                    </a>
                                </li> */}
                                <li class="nav-item active">
                                    <a class="nav-link"
                                        href="/Mint"
                                    >
                                        Mint Now
                                    </a>
                                </li>
                            </ul>
                            <div className='v-center h-center socialicons'>
                                {/* <div className='d-sm-flex d-block justify-content-center align-items-center text-center v-center mr-3'>
                                    <a href="/Minting">
                                        <div class="walletBtn d-flex justify-content-center align-items-center mt-sm-0 mt-4 pl-3 pr-3">
                                            <p>CONNECT</p>
                                        </div>
                                    </a>
                                </div> */}
                                <div className="">
                                    <a href="https://twitter.com/_TomCatJr_" target="_blank" >
                                        <img className="mr-3 discord" src={twitter}></img>
                                    </a>
                                    <a href="https://discord.gg/2kQ94Nt5p7" target="_blank" >
                                        <img className="mr-3 discord" src={discord}></img>
                                    </a>
                                    <a href="https://www.instagram.com/dirtytacoandtequila/?hl=en" target="_blank" >
                                        <img className="mr-3 discord" src={insta}></img>
                                    </a>
                                    <a href="https://opensea.io/collection/artaxianft" target="_blank" >
                                        <img className="discord" src={opensea}></img>
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        );
    }
}
